var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("InstantLetteringController", ["$rootScope",
    "$scope", "instantLetteringService", "cartService", "configs", "$timeout", "$location",
    function ($rootScope, $scope, instantLetteringService, cartService, configs, $timeout, $location) {
        var timer;
        $scope.initialise = function () {
            $scope.spacing = 50;
            $scope.fontAllow = "";
            $scope.align = "jtCenter";
            $scope.firstlinecolor = "#000";
            $scope.secondlinecolor = "#000";
            $scope.firstlinecolor2 = "#000";
            $scope.secondlinecolor2 = "#000";
            $scope.selectedFormat = "dst";
            $scope.requestId = "";
            $scope.availableFormats = "";
            $scope.isMultiColourFont = false;
            $scope.templateObj = {};
            $scope.phrase = {
                first_line: "",
                second_line: ""
            };
            $scope.styleObj = {};
            $scope.fonts = [{
                id: 0,
                incrementSize: 0,
                isActive: false,
                isAllCaps: false,
                isMonogram: false,
                isMultiColour: false,
                keystrokes: "",
                maxSize: 0,
                minSize: 0,
                name: "",
                noOfColors: 0,
                type: "",
                unicodes: ""
            }];
            $scope.fontSizes = [{
                text: "",
                val: 0
            }];
            $scope.font1 = "";
            $scope.availableCharacters = ""
            $scope.showStageOne = true;
            $scope.showStageTwo = false;
            $scope.showStageThree = false;
            $scope.showStageFour = false;
            $scope.stages = [
                {
                    title: "Template",
                    isActive: true
                },
                {
                    title: "Phrase",
                    isActive: false
                },
                {
                    title: "Style",
                    isActive: false
                },
                {
                    title: "Colors",
                    isActive: false
                }
            ];
            $scope.templates = [
                {
                    "type": "one_line",
                    "samples": [
                        "singleline", "upperarcsingleline", "downwardarcsingleline"
                    ]
                },
                {
                    "type": "two_lines",
                    "samples": [
                        "doubleline", "downwardsemicircledoubleline", "upwardsemicircledoubleline", "circulardoubleline"
                    ]
                }
            ];

            $scope.stitchCount = 0;
            $scope.designHeight = 0;
            $scope.designWidth = 0;

            var url = $location.absUrl();
            if (url != "" && url.includes("?")) {
                var urlSplit = url.split("?");

                var paramSplit = urlSplit[1].split("&");

                var oid = "";
                var rid = "";
                var uid = "";

                for (var i = 0; i < paramSplit.length; i++) {
                    if (i == 0) {
                        oid = paramSplit[i].split("=")[1];
                    } else if (i == 1) {
                        rid = paramSplit[i].split("=")[1];
                    } else if (i == 2) {
                        uid = paramSplit[i].split("=")[1];
                    }
                }

                if (oid != "" && rid != "" && uid != "") {
                    instantLetteringService.getExistingLetteringDetails(oid, rid, uid).then(function (response) {
                        $scope.requestId = rid;

                        $scope.editLetteringItem = response.data;
                        if ($scope.editLetteringItem.templateId.toLowerCase() == 'singleline' || $scope.editLetteringItem.templateId.toLowerCase() == 'upperarcsingleline' || $scope.editLetteringItem.templateId.toLowerCase() == 'downwardarcsingleline') {
                            document.getElementById("one_line").click();
                        } else if ($scope.editLetteringItem.templateId.toLowerCase() == 'doubleline' || $scope.editLetteringItem.templateId.toLowerCase() == 'downwardsemicircledoubleline' || $scope.editLetteringItem.templateId.toLowerCase() == 'upwardsemicircledoubleline' || $scope.editLetteringItem.templateId.toLowerCase() == 'circulardoubleline') {
                            document.getElementById("two_lines").click();
                        }

                        $scope.setDefaultTemplate(0, $scope.templateObj, $scope.editLetteringItem.templateId);
                    })
                }
            }
        }

        $scope.getFonts = function () {
            instantLetteringService.getFonts().then(function (response) {
                if (response && response.data && response.data.responseStatus) {
                    $scope.fonts = response.data.data;
                    $scope.font1 = $scope.fonts[0].name;
                    $scope.fontAllow = $scope.fonts[0].unicodes;
                    $scope.onFontChange(true);
                }
                else {
                    console.log('Error while fetching fonts');
                }
            });
        }

        $scope.keyispressed = function (e) {
            if ($scope.fontAllow.split(' ').indexOf(e.key) > -1 || e.key == undefined || e.keyCode == 32 || e.keyCode == 8 || e.keyCode == 13 || e.keyCode == 17 || e.keyCode == 20 || e.keyCode == 16 || e.keyCode == 9) {
                return true;
            }
            else {
                alert('Invalid Character. View Available Characters to select Valid ones');
                e.preventDefault();
            }
        }

        $scope.initialise();
        $scope.getFonts();

        $scope.renderLetter = function () {
            $rootScope.showLoader = true;
            var lp = {
                requestId: $scope.requestId,
                templateId: $scope.templateObj.template,
                text: $scope.phrase.first_line == '' ? 'SAMPLE LINE 1' : $scope.phrase.first_line,
                font: $scope.font1,
                height: Number($scope.fontSize1 * 10),
                justification: $scope.align,
                recipe: $scope.styleObj.recipe,
                palette: [
                    $scope.firstlinecolor.replace('#', '').padStart(6, "0")
                ],
                envelope: $scope.styleObj.envelope
            }
            if ($scope.isMultiColourFont) {
                lp.palette.push($scope.firstlinecolor2.replace('#', '').padStart(6, "0"));
            }
            //console.table(lp);
            instantLetteringService.renderLetteringDesign(lp).then(function (response) {
                if (response && response.data && response.data.responseStatus) {
                    $scope.templateObj.renderImg = configs.ilImageBaseUrl + response.data.data + "?" + Math.random();
                    $scope.requestId = response.data.data.split('.')[0];
                }
                $rootScope.showLoader = false;
            });
        }

        $scope.renderCompound = function () {
            $rootScope.showLoader = true;
            var lp1 = {
                requestId: $scope.requestId,
                templateId: $scope.templateObj.template,
                text: $scope.phrase.first_line == '' ? 'SAMPLE LINE 1' : $scope.phrase.first_line,
                font: $scope.font1,
                height: Number($scope.fontSize1 * 10),
                justification: $scope.align,
                recipe: $scope.styleObj.recipe,
                palette: [
                    $scope.firstlinecolor.replace('#', '').padStart(6, "0")
                ],
                envelope: $scope.styleObj.envelope
            }

            if ($scope.isMultiColourFont) {
                lp1.palette.push($scope.firstlinecolor2.replace('#', '').padStart(6, "0"));
            }

            var lp2 = {
                requestId: $scope.requestId,
                templateId: $scope.templateObj.template,
                text: $scope.phrase.second_line == '' ? 'SAMPLE LINE 2' : $scope.phrase.second_line,
                font: $scope.font1,
                height: Number($scope.fontSize2 * 10),
                justification: $scope.align,
                recipe: $scope.styleObj.recipe,
                palette: [
                    $scope.secondlinecolor.replace('#', '').padStart(6, "0")
                ],
                envelope: $scope.styleObj.envelope
            }

            if ($scope.isMultiColourFont) {
                lp2.palette.push($scope.secondlinecolor2.replace('#', '').padStart(6, "0"));
            }
            var compoundParameter = {
                letteringElements: [],
                layout: "",
                stackedSpacing: ($scope.spacing).toString(),
                requestId: $scope.requestId
            }

            compoundParameter.letteringElements.push(lp1);
            compoundParameter.letteringElements.push(lp2);
            //console.table(compoundParameter);
            instantLetteringService.renderCompoundDesign(compoundParameter).then(function (response) {
                if (response && response.data && response.data.responseStatus) {
                    $scope.templateObj.renderImg = configs.ilImageBaseUrl + response.data.data + "?" + Math.random();
                    $scope.requestId = response.data.data.split('.')[0];
                }
                $rootScope.showLoader = false;
            });
        }

        $scope.renderImage = function () {
            if ($scope.isTwoLines) {
                $scope.renderCompound();
            }
            else {
                $scope.renderLetter();
            }
        }

        $scope.getInfoLetter = function () {
            $rootScope.showLoader = true;
            $scope.letteringParameter = {
                requestId: $scope.requestId,
                templateId: $scope.templateObj.template,
                text: $scope.phrase.first_line,
                font: $scope.font1,
                height: Number($scope.fontSize1 * 10),
                justification: $scope.align,
                recipe: $scope.styleObj.recipe,
                palette: [
                    $scope.firstlinecolor.replace('#', '').padStart(6, "0")
                ],
                envelope: $scope.styleObj.envelope
            }
            //console.table($scope.letteringParameter);
            instantLetteringService.getInfoLetteringDesign($scope.letteringParameter).then(function (response) {
                if (response && response.data && response.data.responseStatus) {
                    $scope.stitchCount = response.data.data.stitches;
                    $scope.designHeight = response.data.data.height;
                    $scope.designWidth = response.data.data.width;
                    $scope.availableFormats = response.data.data.availableFormats.split(',');
                    $scope.selectedFormat = $scope.availableFormats[0];

                    if ($scope.editLetteringItem != null && $scope.editLetteringItem.downloadFormat != null && $scope.editLetteringItem.downloadFormat != "") {
                        $scope.selectedFormat = $scope.editLetteringItem.downloadFormat;
                    }
                }
                $rootScope.showLoader = false;
            });
        }

        $scope.getInfoCompound = function () {
            $rootScope.showLoader = true;
            var lp1 = {
                requestId: $scope.requestId,
                templateId: $scope.templateObj.template,
                text: $scope.phrase.first_line,
                font: $scope.font1,
                height: Number($scope.fontSize1 * 10),
                justification: $scope.align,
                recipe: $scope.styleObj.recipe,
                palette: [
                    $scope.firstlinecolor.replace('#', '').padStart(6, "0")
                ],
                envelope: $scope.styleObj.envelope
            }

            var lp2 = {
                requestId: $scope.requestId,
                templateId: $scope.templateObj.template,
                text: $scope.phrase.second_line,
                font: $scope.font1,
                height: Number($scope.fontSize2 * 10),
                justification: $scope.align,
                recipe: $scope.styleObj.recipe,
                palette: [
                    $scope.secondlinecolor.replace('#', '').padStart(6, "0")
                ],
                envelope: $scope.styleObj.envelope
            }
            $scope.compoundParameter = {
                letteringElements: [],
                layout: "",
                stackedSpacing: ($scope.spacing).toString(),
                requestId: $scope.requestId
            }

            $scope.compoundParameter.letteringElements.push(lp1);
            $scope.compoundParameter.letteringElements.push(lp2);
            //console.table($scope.compoundParameter);
            instantLetteringService.getInfoCompoundDesign($scope.compoundParameter).then(function (response) {
                if (response && response.data && response.data.responseStatus) {
                    $scope.stitchCount = response.data.data.stitches;
                    $scope.designHeight = response.data.data.height;
                    $scope.designWidth = response.data.data.width;
                    $scope.availableFormats = response.data.data.availableFormats.split(',');
                    $scope.selectedFormat = $scope.availableFormats[0];

                    if ($scope.editLetteringItem != null && $scope.editLetteringItem.downloadFormat != null && $scope.editLetteringItem.downloadFormat != "") {
                        $scope.selectedFormat = $scope.editLetteringItem.downloadFormat;
                    }
                }
                $rootScope.showLoader = false;
            });
        }

        $scope.getInfo = function () {
            if ($scope.isTwoLines) {
                $scope.getInfoCompound();
            }
            else {
                $scope.getInfoLetter();
            }
        }

        $scope.addILItemToCart = function () {
            $rootScope.showLoader = true;
            var e = document.getElementById('formats');
            var ilItem = {
                RequestId: $scope.requestId,
                TemplateId: $scope.templateObj.template,
                Recipe: $scope.styleObj.recipe,
                IsStitchCenterOut: "false",
                IsTwoLines: $scope.isTwoLines,
                Line1Text: "",
                Line1Font: $scope.font1,
                Line1FontSize: 0,
                Line1Color: $scope.firstlinecolor.replace('#', '').padStart(6, "0"),
                Line2Text: "",
                Line2Font: $scope.font1,
                Line2FontSize: 0,
                Line2Color: $scope.secondlinecolor.replace('#', '').padStart(6, "0"),
                SpacingBetweenLines: $scope.spacing,
                Justify: $scope.align,
                Height: $scope.designHeight,
                Width: $scope.designWidth,
                DownloadFormat: e.value,
                ThreadManufacturer: "",
                Envelope: $scope.styleObj.envelope,
                AvailableFormats: $scope.availableFormats.join(',')
            }
            if ($scope.isTwoLines) {
                ilItem.Line1Text = $scope.compoundParameter.letteringElements[0].text;
                ilItem.Line1FontSize = $scope.compoundParameter.letteringElements[0].height;
                ilItem.Line2Text = $scope.compoundParameter.letteringElements[1].text;
                ilItem.Line2FontSize = $scope.compoundParameter.letteringElements[1].height;
            }
            else {
                ilItem.Line1Text = $scope.letteringParameter.text;
                ilItem.Line1FontSize = $scope.letteringParameter.height;
            }
            //console.table(ilItem);
            cartService.addInstantLetteringItemToCart(ilItem).then(
                function (response) {
                    if (response && response.data && response.data.itemAdded) {
                        $rootScope.$broadcast("CustomerCartChanged");
                        if (typeof gtag !== 'undefined') {
                            gtag('event', 'add_to_cart', {
                                'event_category': 'instant_lettering',
                                'event_action': 'add_to_cart'
                            });
                        }
                        $scope.initialise();
                        window.location.href = "/cart";
                    }
                    else {
                        $rootScope.showLoader = false;
                        alert('Failed to add product to cart.');
                    }
                });
        }

        $scope.updateColor1 = function (color, num) {
            if (num == 1)
                $scope.firstlinecolor = color;
            if (num == 2)
                $scope.firstlinecolor2 = color;
            $scope.renderImage();
        }

        $scope.updateColor2 = function (color, num) {
            if (num == 1)
                $scope.secondlinecolor = color;
            if (num == 2)
                $scope.secondlinecolor2 = color;
            $scope.renderImage();
        }

        $scope.addSpace = function () {
            $scope.spacing = $scope.spacing > -90 ? $scope.spacing - 10 : -90;
            $timeout.cancel(timer);
            timer = $timeout(function () {
                $scope.renderImage();
            }, 350);
        }

        $scope.minusSpace = function () {
            $scope.spacing = $scope.spacing < 90 ? $scope.spacing + 10 : 90;
            $timeout.cancel(timer);
            timer = $timeout(function () {
                $scope.renderImage();
            }, 350);
        }

        $scope.onFontChange = function (isFirstLoad) {
            selectedFont = $scope.fonts.filter(function (item) {
                return item.name.toLowerCase() == $scope.font1.toLowerCase();
            });
            $scope.isMultiColourFont = selectedFont[0].isMultiColour;
            var minSizemm = selectedFont[0].minSize;
            var maxSizemm = selectedFont[0].maxSize;
            var minSizein = minSizemm / 25.4;
            var maxSizein = maxSizemm / 25.4;

            var tempminSizemm = minSizemm.toString();

            if (tempminSizemm.includes(".")) {
                var split = tempminSizemm.split(".");

                if (split[1].length == 1) {
                    tempminSizemm = tempminSizemm + "0";
                }
            } else {
                tempminSizemm = tempminSizemm + ".00";
            }

            var tempmaxSizemm = maxSizemm.toString();

            if (tempmaxSizemm.includes(".")) {
                var split = tempmaxSizemm.split(".");

                if (split[1].length == 1) {
                    tempmaxSizemm = tempmaxSizemm + "0";
                }
            } else {
                tempmaxSizemm = tempmaxSizemm + ".00";
            }


            $scope.fontSizes = [];
            $scope.fontSizes.push({
                text: minSizemm.toFixed(2) + "mm" + " / " + minSizein.toFixed(2) + "\"",
                val: tempminSizemm.toString()
            });
            $scope.fontSize1 = minSizemm.toFixed(2).toString();
            $scope.fontSize2 = minSizemm.toFixed(2).toString();
            $scope.fontAllow = selectedFont[0].unicodes;
            var nextIncrement = selectedFont[0].incrementSize;
            if (minSizemm != maxSizemm) {
                while (nextIncrement < maxSizemm) {
                    $scope.fontSizes.push({
                        text: nextIncrement.toFixed(2) + "mm" + " / " + (nextIncrement / 25.4).toFixed(2) + "\"",
                        val: nextIncrement.toFixed(2).toString()
                    });
                    nextIncrement = nextIncrement + 3.2;
                }

                $scope.fontSizes.push({
                    text: maxSizemm.toString() + "mm" + " / " + maxSizein.toFixed(2) + "\"",
                    val: tempmaxSizemm.toString()
                });
            }

            $scope.availableCharacters = "<b>* min size: </b>" + minSizemm.toString() + " mm or " + minSizein.toFixed(2) + " inches<br><b>* max size: </b>" + maxSizemm.toString() + " mm or " + maxSizein.toFixed(2) + "  inches<br><b>* Number of Colors: </b> " + selectedFont[0].noOfColors + "<br><b>* Available KeyStrokes: </b>" + selectedFont[0].unicodes;
            $scope.phrase.second_line = "";
            $scope.phrase.first_line = "";
            if (!isFirstLoad)
                $scope.renderImage();
        }

        $scope.getFontImg = function (fontName) {
            if (angular.isDefined(fontName) && fontName != null) {
                return fontName.replace(/\s/g, "_");
            }
            else
                return "";
        }

        $scope.updateActiveStage = function (currentStg) {
            for (var i = 0; i < $scope.stages.length; i++) {
                $scope.stages[i].isActive = i <= currentStg;
            }
        }

        $scope.onNextClick = function (stg, form, isBack) {
            if (stg.toString().toLowerCase() == "stage0") {
                $scope.showStageOne = true;
                $scope.showStageTwo = false;
                $scope.showStageThree = false;
                $scope.showStageFour = false;
                $scope.showStageFive = false;
                $scope.updateActiveStage(0);
            }
            else if (stg.toString().toLowerCase() == "stage1") {
                $scope.showStageOne = false;
                $scope.showStageTwo = true;
                $scope.showStageThree = false;
                $scope.showStageFour = false;
                $scope.showStageFive = false;
                $scope.updateActiveStage(1);
                if (angular.isDefined(form.lineNumber)) {
                    $scope.isTwoLines = form.lineNumber.$viewValue.toLowerCase() == 'two_lines';
                }

                if (!isBack) {
                    if ($scope.editLetteringItem != null) {
                        if ($scope.editLetteringItem.line1Text != null && $scope.editLetteringItem.line1Text != '') {
                            $timeout(function () { $scope.phrase.first_line = $scope.editLetteringItem.line1Text; }, 300);
                        }

                        if ($scope.editLetteringItem.line2Text != null && $scope.editLetteringItem.line2Text != '') {
                            $timeout(function () { $scope.phrase.second_line = $scope.editLetteringItem.line2Text; }, 300);
                        }

                        $scope.font1 = $scope.editLetteringItem.line1Font;

                        $scope.onFontChange(false);
                    }

                    $scope.renderImage();
                }
            }
            else if (stg.toString().toLowerCase() == "stage2") {
                if (angular.isDefined(form) && form.$invalid) {
                    $scope.isPhraseFormSubmitted = true;
                }
                else {
                    $scope.showStageOne = false;
                    $scope.showStageTwo = false;
                    $scope.showStageThree = true;
                    $scope.showStageFour = false;
                    $scope.showStageFive = false;
                    $scope.stages[2].isActive = true;

                    if (!isBack) {
                        if ($scope.editLetteringItem != null) {
                            if ($scope.editLetteringItem.line1FontSize != null && $scope.editLetteringItem.line1FontSize != '') {
                                var tempFontSize1 = ($scope.editLetteringItem.line1FontSize / 10).toString();

                                if (tempFontSize1.includes(".")) {
                                    var split = tempFontSize1.split(".");

                                    if (split[1].length == 1) {
                                        tempFontSize1 = tempFontSize1 + "0";
                                    }
                                } else {
                                    tempFontSize1 = tempFontSize1 + ".00";
                                }

                                $scope.fontSize1 = tempFontSize1;
                            }

                            if ($scope.editLetteringItem.line2FontSize != null && $scope.editLetteringItem.line2FontSize != '' && $scope.isTwoLines) {
                                var tempFontSize2 = ($scope.editLetteringItem.line2FontSize / 10).toString();

                                if (tempFontSize2.includes(".")) {
                                    var split = tempFontSize2.split(".");

                                    if (split[1].length == 1) {
                                        tempFontSize2 = tempFontSize2 + "0";
                                    }
                                } else {
                                    tempFontSize2 = tempFontSize2 + ".00";
                                }

                                $scope.fontSize2 = tempFontSize2;
                            }

                            if ($scope.editLetteringItem.spacingBetweenLines != null && $scope.editLetteringItem.spacingBetweenLines != '' && $scope.isTwoLines) {
                                $scope.spacing = $scope.editLetteringItem.spacingBetweenLines;
                            }

                            if ($scope.editLetteringItem.justify != null && $scope.editLetteringItem.justify != '') {
                                $scope.onAlignChange($scope.editLetteringItem.justify);
                            }

                            if ($scope.editLetteringItem.recipe != null && $scope.editLetteringItem.recipe != '') {
                                $scope.styleObj.recipe = $scope.editLetteringItem.recipe;
                            }

                            if ($scope.editLetteringItem.envelope != null && $scope.editLetteringItem.envelope != '') {
                                $scope.styleObj.envelope = $scope.editLetteringItem.envelope;
                            }
                        }

                        $scope.renderImage();
                    }
                    $scope.updateActiveStage(2);
                }
            }
            else if (stg.toString().toLowerCase() == "stage3") {
                $scope.showStageOne = false;
                $scope.showStageTwo = false;
                $scope.showStageThree = false;
                $scope.showStageFour = true;
                $scope.showStageFive = false;
                $scope.stages[3].isActive = true;
                if (!isBack) {
                    if ($scope.editLetteringItem != null) {
                        if ($scope.editLetteringItem.line1Color != null && $scope.editLetteringItem.line1Color != '') {
                            $scope.firstlinecolor = "#" + $scope.editLetteringItem.line1Color;
                            $scope.updateColor1($scope.firstlinecolor);
                        }

                        if ($scope.editLetteringItem.line2Color != null && $scope.editLetteringItem.line2Color != '' && $scope.isTwoLines) {
                            $scope.secondlinecolor = "#" + $scope.editLetteringItem.line2Color;
                            $scope.updateColor2($scope.secondlinecolor);
                        }
                    }

                    $scope.renderImage();
                }
                $scope.updateActiveStage(3);
            }
            else if (stg.toString().toLowerCase() == "stage4") {
                $scope.showStageOne = false;
                $scope.showStageTwo = false;
                $scope.showStageThree = false;
                $scope.showStageFour = true;
                $scope.showStageFive = true;



                $scope.getInfo();
            }
        }

        $scope.onAlignChange = function (val) {
            $scope.align = val;
            $scope.renderImage();
        }

        $scope.setDefaultTemplate = function (index, form, templateName) {
            if ($scope.editLetteringItem != null && $scope.editLetteringItem.templateId != null) {
                form.template = $scope.editLetteringItem.templateId;
            } else {
                form.template = templateName;
            }
        }

        $scope.toggleModal = function (mdl, state) {
            $scope[mdl] = angular.isUndefined(state) ? false : state;
        }

        $scope.updateILItem = function() {
            if (confirm("Are you sure you want to update the Instant Lettering Item?")) {
                $rootScope.showLoader = true;

                var e = document.getElementById('formats');
                var ilItem = {
                    RequestId: $scope.editLetteringItem.requestId,
                    TemplateId: $scope.templateObj.template,
                    Recipe: $scope.styleObj.recipe,
                    IsStitchCenterOut: "false",
                    IsTwoLines: $scope.isTwoLines,
                    Line1Text: "",
                    Line1Font: $scope.font1,
                    Line1FontSize: 0,
                    Line1Color: $scope.firstlinecolor.replace('#', '').padStart(6, "0"),
                    Line2Text: "",
                    Line2Font: $scope.font1,
                    Line2FontSize: 0,
                    Line2Color: $scope.secondlinecolor.replace('#', '').padStart(6, "0"),
                    SpacingBetweenLines: $scope.spacing,
                    Justify: $scope.align,
                    Height: $scope.designHeight,
                    Width: $scope.designWidth,
                    DownloadFormat: e.value,
                    ThreadManufacturer: "",
                    Envelope: $scope.styleObj.envelope,
                    LineItemId: $scope.editLetteringItem.lineItemId
                }
                if ($scope.isTwoLines) {
                    ilItem.Line1Text = $scope.compoundParameter.letteringElements[0].text;
                    ilItem.Line1FontSize = $scope.compoundParameter.letteringElements[0].height;
                    ilItem.Line2Text = $scope.compoundParameter.letteringElements[1].text;
                    ilItem.Line2FontSize = $scope.compoundParameter.letteringElements[1].height;
                }
                else {
                    ilItem.Line1Text = $scope.letteringParameter.text;
                    ilItem.Line1FontSize = $scope.letteringParameter.height;
                }
                instantLetteringService.updateInstantLetteringItem(ilItem).then(function (response) {
                    $rootScope.showLoader = false;
                    if (response.data) {
                        $scope.updateResponse = "Success. The Instant Lettering item has been updated. Please close the window and download from the admin.";
                    } else {
                        $scope.updateResponse = "Error. The Instant Lettering item could not be updated. Please contact an admin.";
                    }

                    $scope.showUpdateModal = true;
                })
            }
        }
    }
]);
